import { Component, inject, Input, OnInit } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslocoPipe } from '@jsverse/transloco';
import { QuestionBoxComponent } from '@shared/components/question-box/question-box.component';
import { PremiumDisplayComponent } from '@shared/components/premium-display/premium-display.component';
import { NgClass } from '@angular/common';
import { startWith, switchMap, takeUntil } from 'rxjs';
import { countryAnswerOptions } from '@shared/models/country-registered-answer-options';
import { SkipperHaftpflichtComponent } from '../skipper-haftpflicht/skipper-haftpflicht.component';
import { SkipperRechtsschutzComponent } from '../skipper-rechtsschutz/skipper-rechtsschutz.component';
import { DataBaseComponent } from '@shared/directives/data-base.component';
import { SkipperFormModel } from '@shared/models/forms/skipper-form.model';
import { SkipperCalculationService } from '../../services/skipper-calculation.service';
import { environment } from '@environment/environment';
import { CallidusSkipperVersicherungssummeKunde } from '@backend/models';

@Component({
  selector: 'app-skipper-general',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    TranslocoPipe,
    QuestionBoxComponent,
    PremiumDisplayComponent,
    NgClass,
    SkipperHaftpflichtComponent,
    SkipperRechtsschutzComponent
  ],
  templateUrl: './skipper-general.component.html',
  styleUrl: './skipper-general.component.scss'
})
export class SkipperGeneralComponent extends DataBaseComponent implements OnInit {
  @Input() form!: FormGroup<SkipperFormModel>;

  protected readonly skipperCalculationService = inject(SkipperCalculationService);

  protected readonly countryAnswerOptions = countryAnswerOptions;
  showCalculationPremiumEnabled = environment.featureToggles.showCalculationPremiumEnabled;

  ngOnInit(): void {
    this.form.valueChanges
      .pipe(
        startWith(this.form.value),
        switchMap(() => this.skipperCalculationService.calculate(this.form)),
        takeUntil(this.componentDestroyed$)
      )
      .subscribe();

    this.form.controls.isKundeSkipperVertragsHaftpflichtSelected.valueChanges.pipe(takeUntil(this.componentDestroyed$)).subscribe((value) => {
      if (value) {
        this.form.controls.skipperHaftpflicht.controls.callidusSkipperVersicherungssummeKunde.setValue(CallidusSkipperVersicherungssummeKunde.Versicherungssumme5Mio);
      }
    });
  }

  canShowCalculationsResult(): boolean {
    return this.skipperCalculationService.getCalculationResult() !== null && (!!this.form.controls.isKundeSkipperVertragsRechtsschutzSelected.value || !!this.form.controls.isKundeSkipperVertragsHaftpflichtSelected.value);
  }
}
